import { Platform } from 'react-native';
import * as semver from 'semver';

import { appVersion } from 'utils/app-version-info';
import { isWeb, region } from 'utils/environment';
import { Region } from 'utils/environment/types';
import { noCircularLogger } from 'utils/logger/no-circular-logger';

const MINIMUM_ANDROID_VERSION = '7.11.0';
const MINIMUM_IOS_VERSION = '7.13.0';

export const isPayPalSupported = (): boolean => {
  // PayPal is only supported in the US
  if (region !== Region.US) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: PayPal',
      reason: 'Region is not supported',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  // Validate app version
  if (!semver.valid(appVersion)) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: PayPal',
      reason: 'Invalid app version',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  // Check minimum Android version
  if (Platform.OS === 'android' && semver.lt(appVersion, MINIMUM_ANDROID_VERSION)) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: PayPal',
      reason: 'Current android app version is not supported',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  // Check minimum iOS version
  if (Platform.OS === 'ios' && semver.lt(appVersion, MINIMUM_IOS_VERSION)) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: PayPal',
      reason: 'Current IOS app version is not supported',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  return true;
};

export const isVenmoSupported = (): boolean => {
  // Venmo is only supported in the US
  if (region !== Region.US) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: Venmo',
      reason: 'Region is not supported',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  // Validate app version
  if (!semver.valid(appVersion)) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: Venmo',
      reason: 'Invalid app version',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  // Check minimum Android version
  if (Platform.OS === 'android' && semver.lt(appVersion, MINIMUM_ANDROID_VERSION)) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: Venmo',
      reason: 'Current android app version is not supported',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  // Check minimum iOS version
  if (Platform.OS === 'ios' && semver.lt(appVersion, MINIMUM_IOS_VERSION)) {
    noCircularLogger('info', {
      message: 'Payment Method unavailable: Venmo',
      reason: 'Current IOS app version is not supported',
      region,
      isWeb,
      platform: Platform.OS,
      appVersion,
    });
    return false;
  }

  return true;
};
